import axios from 'axios';
import localStorageService from '../storage/localStorage.service';

// URL base da API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://bot-api.maralabs.com.br';

console.log('🌐 API_BASE_URL:', API_BASE_URL);

// Cria instância do axios
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 30 segundos
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor de requisição - Adiciona token em todas as requisições
api.interceptors.request.use(
  (config) => {
    // Prioriza token temporário (usado quando admin acessa dados de tenant)
    const tempToken = localStorage.getItem('temp_tenant_token');
    const token = tempToken || localStorageService.getAuthToken();
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log de requisições em desenvolvimento
    if (process.env.NODE_ENV === 'development') {
      const tokenType = tempToken ? '(temp)' : '(main)';
      console.log(`📤 ${config.method.toUpperCase()} ${config.url} ${tokenType}`);
    }
    
    return config;
  },
  (error) => {
    console.error('❌ Erro no request interceptor:', error);
    return Promise.reject(error);
  }
);

// Interceptor de resposta - Log de erros
api.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`📥 ${response.config.method.toUpperCase()} ${response.config.url} - ${response.status}`);
    }
    return response;
  },
  (error) => {
    if (error.response) {
      console.error(`❌ ${error.config?.method?.toUpperCase()} ${error.config?.url} - ${error.response.status}`, error.response.data);
    } else if (error.request) {
      console.error('❌ Sem resposta do servidor:', error.message);
    } else {
      console.error('❌ Erro na requisição:', error.message);
    }
    return Promise.reject(error);
  }
);

/**
 * Função auxiliar para fazer requisições GET
 */
export const get = (url, config = {}) => {
  return api.get(url, config);
};

/**
 * Função auxiliar para fazer requisições POST
 */
export const post = (url, data = {}, config = {}) => {
  return api.post(url, data, config);
};

/**
 * Função auxiliar para fazer requisições PUT
 */
export const put = (url, data = {}, config = {}) => {
  return api.put(url, data, config);
};

/**
 * Função auxiliar para fazer requisições PATCH
 */
export const patch = (url, data = {}, config = {}) => {
  return api.patch(url, data, config);
};

/**
 * Função auxiliar para fazer requisições DELETE
 */
export const del = (url, config = {}) => {
  return api.delete(url, config);
};

export default api;